<template>
  <SupportPageCard
    page-class="work-temp-page"
    :title="tempName || ''"
    :show-back="!hideBackBtn"
    @back="goBack"
  >
    <van-form
      v-if="!visibleLoading"
      class="form work-temp-form"
      ref="formRef"
      @submit="beforeSubmit"
    >
      <NetDetect
        v-if="netDetect.showNetDetect"
        @startNetDetect="updateNetDetect"
      ></NetDetect>
      <component
        :is="compType[item.isCustomComp ? item.type : item.formType]"
        v-for="item in formList"
        :key="item.id"
        :id="item.id"
        :type="item.type"
        :formData="formData"
        :labelInfo="item.labelInfo"
        :customKey="item.customKey"
        :gameId="gameId"
        :required="item.required"
        :label="item.label"
      ></component>
      <p class="agreement" v-if="showDeleteAccountAgreement">
        <span @click="jumpAgreement">Account Cancellation Agreement</span>
      </p>
    </van-form>

    <template v-if="!visibleLoading && !isReview" #footer>
      <div class="form-item-submit">
        <van-button
          class="btn"
          block
          type="info"
          :loading="loadingSubmit"
          @click="onFooterSubmit"
        >
          <template #icon>
            <em class="btn-icon iconfont icon-info"></em>
          </template>
          <template>{{ languages.submit }}</template>
        </van-button>
      </div>
    </template>

    <template #overlay>
      <van-overlay :show="visibleLoading">
        <div class="loading-wrapper" @click.stop>
          <van-loading color="#1989fa" size="40" />
        </div>
      </van-overlay>
    </template>
  </SupportPageCard>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Overlay, Loading } from 'vant';
import SupportPageCard from '@components/officialSupport/common/SupportPageCard.vue';
import TempSelect from '@components/officialSupport/workTemp/TempSelect.vue';
import TempInput from '@components/officialSupport/workTemp/TempInput.vue';
import TempSwitch from '@components/officialSupport/workTemp/TempSwitch.vue';
import TempDateTimePicker from '@components/officialSupport/workTemp/TempDateTimePicker.vue';
import TempUpload from '@components/officialSupport/workTemp/TempUpload.vue';
import TempOrder from '@components/officialSupport/workTemp/TempOrder.vue';
import TempAccountType from '@components/officialSupport/workTemp/TempAccountType.vue';
import TempServer from '@components/officialSupport/workTemp/TempServer.vue';
import NetDetect from '@components/officialSupport/NetDetect.vue';
import bridge from '@utiles/bridge';
import {
  formType,
  fieldType,
  workTempType
} from '@configs/officialSupport/workTemp';
import { DELETE_ACCOUNT_WORK_TEMP_ID } from '@configs/officialSupport/accountDelete';
import globalConfig from '@utiles/globalConfig';
import {
  clickButton,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import { getOrderSourceParams } from '@utiles/officialSupport';
import { ORDER_SUBMIT_SOURCE } from '@configs/officialSupport/orderSubmitSource';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const isReview = globalConfig.getHrefParam('isReview') == 1;
const hideBackBtn = globalConfig.getHrefParam('hideBackBtn') == 1;
export default {
  name: 'WorkTemp',
  mixins: [iframeMessage, pointStayTime],
  data() {
    return {
      loadingSubmit: false,
      timer: null,
      submitSucc: false,
      tempId: null,
      tempName: null,
      tempType: null,
      formData: {},
      formList: [],
      compType: {
        [formType.input]: TempInput,
        [formType.select]: TempSelect,
        [formType.switch]: TempSwitch,
        [formType.date]: TempDateTimePicker,
        [formType.upload]: TempUpload,
        [fieldType.order]: TempOrder,
        [fieldType.accountType]: TempAccountType,
        [fieldType.server]: TempServer
      },
      netDetect: {
        showNetDetect: false,
        hasNetDetect: false
      },
      gameId:
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id'),
      isAllowNoLogin: false, // 是否允许无登录提单
      loadingPage: false,
      isReview,
      visibleLoading: true,
      hideBackBtn
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      urlParams: state => state.urlParams,
      curLang: state => state.curLang,
      defaultLang: state => state.defaultLang,
      isIframe: state => state.isIframe,
      isJumpAiBot: state => state.isJumpAiBot,
      isLogin: state => state.isLogin
    }),
    workTempId() {
      return this.$route.query.workTempId;
    },
    isSupportSdkDiagnosis() {
      return (
        bridge.runInsdk() &&
        globalConfig.getHrefParam('isSupportSdkDiagnosis') == '1'
      );
    },
    isUploadSdkLog() {
      return (
        this.isSupportSdkDiagnosis &&
        [workTempType.store, workTempType.abnormal].includes(this.tempType)
      );
    },
    // 账号删除协议入口：仅认模板 id，游戏范围由大麦智能工单全局规则配置，无需在此维护 gameId 白名单
    showDeleteAccountAgreement() {
      return this.workTempId == DELETE_ACCOUNT_WORK_TEMP_ID;
    }
  },
  methods: {
    ...mapActions(['createWork', 'getWorkTempDetail', 'callPopupForm']),
    /** 兼容部分构建/运行环境下 getGlobalGetGotoLink 未注入的情况 */
    safeGotoLink(link) {
      if (typeof getGlobalGetGotoLink !== 'function') {
        return link;
      }
      try {
        return getGlobalGetGotoLink({ link });
      } catch (e) {
        return link;
      }
    },
    onFooterSubmit() {
      this.$refs.formRef && this.$refs.formRef.submit();
    },
    uploadLog({ token, uploadId, feedbackId }) {
      bridge.callSdkMethod('uploadLog', {
        feedbackId, // 关联的工单ID
        uploadId, // 日志上传的ID
        token // 日志上传的Token
      });
      window.csorderDataLayer.push({
        eventName: 'upload_log',
        eventValue: {
          feedbackId,
          uploadId,
          token
        }
      });
    },
    updateNetDetect() {
      this.netDetect.hasNetDetect = true;
      clickButton({
        btnName: 'clickNetDetect',
        locationKey: locationType.smartOrderPage
      });
    },
    initNetDetect() {
      if (
        this.isSupportSdkDiagnosis &&
        [workTempType.abnormal].includes(this.tempType)
      ) {
        this.netDetect.showNetDetect = true;
      }
    },
    async initFormData(reviewData) {
      try {
        this.visibleLoading = true;
        let data = '';
        if (reviewData) {
          data = reviewData;
        } else {
          data = await this.getWorkTempDetail({
            workTempId: this.workTempId
          });
        }
        this.tempId = data?.id;
        this.tempName = data?.name;
        try {
          if (this.showDeleteAccountAgreement) {
            const gameData = await this.$store.dispatch('getGame', this.gameId);
            if (gameData?.NAME) {
              this.tempName = gameData.NAME || '';
            }
          }
        } catch (error) {}

        this.tempType = data?.orderType;
        JSON.parse(data.configJson)?.questions.forEach(item => {
          const isCustomComp = [
            fieldType.order,
            fieldType.accountType,
            fieldType.server
          ].includes(item.type);
          let label =
            item?.label_multi_lang?.[this.curLang] ||
            (this.defaultLang && item?.label_multi_lang?.[this.defaultLang]) ||
            item?.label_multi_lang?.['en-US'] ||
            '';
          let tip =
            item?.tip_multi_lang?.[this.curLang] ||
            (this.defaultLang && item?.tip_multi_lang?.[this.defaultLang]) ||
            item?.tip_multi_lang?.['en-US'] ||
            '';
          label = String(label);
          tip = String(tip);
          this.formList.push({
            ...item,
            label,
            tip,
            labelInfo: {
              label,
              tip,
              required: item?.required || false,
              tipImg: item?.tipImg || []
            },
            innerLabelName: item?.label || '',
            innerLabelTip: item?.tip || '',
            isCustomComp
          });
          this.$set(this.formData, item.id, isCustomComp ? {} : null);
        });
        console.log('formList', this.formList);
        this.visibleLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    checkHasUploadImg(formData) {
      return formData.some(item => {
        if ([fieldType.order, fieldType.upload].includes(item.type)) {
          const picItem =
            item.type === fieldType.order
              ? item?.playerSubmit?.image?.pic
              : item?.playerSubmit?.pic;
          return (
            (picItem &&
              picItem !== '' &&
              picItem !== '[]' &&
              JSON.parse(picItem)?.length > 0) ||
            false
          );
        }
        return false;
      });
    },
    getFormDataAccount(formData) {
      return (
        formData.find(item => item.type === fieldType.account)?.playerSubmit ||
        ''
      );
    },
    getSubmitParams() {
      const newFormData = [];
      this.formList.forEach(item => {
        newFormData.push({
          ...item,
          playerSubmit: this.formData[item.id],
          autoCheck: item?.autoCheck === false ? false : true
        });
      });
      console.log('newFormData', newFormData);
      return {
        category_id: this.tempType,
        game_id: this.gameId,
        package_version: this.urlParams.packageVersion || '',
        isUploadSdkLog: this.isUploadSdkLog,
        smartOrderCfgId: this.tempId,
        smartOrderContentJson: JSON.stringify({
          formData: newFormData,
          id: this.tempId,
          name: this.tempName,
          orderType: this.tempType,
          hasUploadImg: this.checkHasUploadImg(newFormData),
          account: this.getFormDataAccount(newFormData)
        }),
        character_name: this.urlParams.roleName || '',
        game_server_id: this.urlParams.serverId || '',
        discord_id: this.urlParams.discordId || '',
        frontVersion: `v1_${new Date().getTime()}`,
        isOpenAiEntrance: this.isJumpAiBot,
        pageSource: this.$route.query.source || '',
        front_url: window.location.href,
        order_submit_source: ORDER_SUBMIT_SOURCE.SMART,
        ...getOrderSourceParams()
      };
    },
    async beforeSubmit(_values) {
      if (!this.isLogin && !this.isAllowNoLogin) {
        let realHref = `https://gabres.${globalConfig.getMainHost()}/platform/login.html?gameId=${this.gameId || ''}&forward=${encodeURIComponent(this.safeGotoLink(window.location.href))}`;
        window.location.href = this.safeGotoLink(realHref);
        return;
      }
      clickButton({
        btnName: 'clickSubmitSmartOrder',
        locationKey: locationType.smartOrderPage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: this.isJumpAiBot,
          isLogin: this.isLogin
        }
      });
      await this.$refs.formRef.validate();

      this.submit();
    },
    async submit() {
      this.loadingSubmit = true;
      // await Promise.all(this.workFileArr.map(item => item.uploadingPromise)); // 这里要处理下上传文件等待过程
      const submitWorkParams = this.getSubmitParams();
      try {
        const res = await this.createWork(submitWorkParams);
        const { insertId, uploadLogId, uploadLogToken } = res?.data?.data;
        if (this.isUploadSdkLog && insertId && uploadLogId && uploadLogToken) {
          this.uploadLog({
            token: uploadLogToken,
            uploadId: uploadLogId,
            feedbackId: insertId
          });
        }
        if (insertId) {
          // 提交成功后调用 popupForm 接口
          await this.callPopupForm({
            isSubmit: 1,
            orderId: insertId,
            gameId: this.gameId,
            workTempId: this.workTempId,
            workTempName: this.tempName || ''
          });
          window.csorderDataLayer.push({
            eventName: 'submit_order',
            eventType: this.tempType || '',
            eventValue: {
              orderId: insertId || '',
              orderType: 'smart',
              frontVersion: `v1_${new Date().getTime()}`,
              isOpenAiEntrance: this.isJumpAiBot,
              isLogin: this.isLogin,
              isIframe: this.isIframe,
              pageSource: this.$route.query.source || ''
            }
          });
          if (this.isIframe) {
            window.csorderDataLayer.push({
              eventName: 'send_to_iframe',
              eventValue: {
                orderId: insertId,
                orderType: 'normal',
                frontVersion: `v1_${new Date().getTime()}`,
                isOpenAiEntrance: this.isJumpAiBot,
                isLogin: this.isLogin,
                isIframe: this.isIframe,
                pageSource: this.$route.query.source || ''
              }
            });
            this.postMessageToParent('createWorkSucc', { orderId: insertId });
          }
        }
        this.$router.push('/mylist');
        this.submitSuccessTip = res?.msg || '';
        this.submitSucc = true;
      } catch (error) {
        console.log(error);
      }
      this.loadingSubmit = false;
    },
    goBack() {
      if (this.isIframe) {
        this.postMessageToParent('goBack');
      } else {
        if (globalConfig.isTiktokMiniProgram()) {
          this.$router.push('/workhome');
        } else {
          this.$router.go(-1);
        }
      }
    },
    jumpAgreement() {
      const url = `https://gpassport.${globalConfig.getMainHost()}/center/ServicePrivacy/customize?keyWord=deleteaccount_en`;
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('openBrowser', {
          url: url,
          loginDir: 1,
          appendParams: 1
        });
      } else {
        window.open(url, '_blank');
      }
    }
  },
  beforeCreate() {
    if (isReview) {
      globalConfig.addEvenListener(async ({ data }) => {
        if (data?.type == 'reviewData' && data?.data?.id) {
          this.initFormData(data.data);
        }
      }, 'message');
    }
  },
  async created() {
    this.isAllowNoLogin =
      !!globalConfig.getCookie('login_failed') ||
      this.workTempId == DELETE_ACCOUNT_WORK_TEMP_ID;
    // 预览模式（isReview=1）,大麦智能工单列表进行查看，无需登录
    // workTempId=74（账号删除送审模板）允许未登录访问
    if (!isReview && !this.isLogin && !this.isAllowNoLogin) {
      let realHref = `https://gabres.${globalConfig.getMainHost()}/platform/login.html?gameId=${
        this.gameId || ''
      }&forward=${encodeURIComponent(this.safeGotoLink(window.location.href))}`;
      window.location.href = this.safeGotoLink(realHref);
      return;
    }
    if (!isReview) {
      try {
        this.loadingPage = true;
        await this.initFormData();
        this.initNetDetect();
        // 提交表单前调用 popupForm 接口
        await this.callPopupForm({
          isSubmit: 0,
          gameId: this.gameId,
          workTempId: this.workTempId,
          workTempName: this.tempName || ''
        });
        window.csorderDataLayer.push({
          eventName: 'view_smart_order',
          eventType: this.tempType,
          eventReason: this.$route.query.source || ''
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingPage = false;
      }
    } else {
      this.postMessageToParent('getPrevieDate');
    }
  },
  components: {
    SupportPageCard,
    Overlay,
    Loading,
    TempSelect,
    TempInput,
    TempSwitch,
    TempDateTimePicker,
    TempUpload,
    TempOrder,
    TempAccountType,
    TempServer,
    NetDetect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
</style>
